import { isAfter, isBefore, isSameDay } from 'date-fns'

import {
  DEADLINE_BG_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_DEFAULT,
  DEADLINE_TEXT_COLOR_EARLY,
  DEADLINE_TEXT_COLOR_OVERDUE,
  DEADLINE_TEXT_COLOR_ROLLING,
} from '../../../constants/date'
import {
  REQUEST_IN_PROGRESS_STATUS,
  REQUEST_PENDING_STATUS,
} from '../../../constants/request'

function isRequestPendingStatus(status) {
  return status === REQUEST_PENDING_STATUS
}

function isRequestInProgressStatus(status) {
  return status === REQUEST_IN_PROGRESS_STATUS
}

function getEntityDeadlineStatusTextColor(deadline) {
  const currentDate = Date.now()

  const isDeadlineDay = isSameDay(deadline, currentDate)
  const isDeadlineAfterCurrentTime = isAfter(deadline, currentDate)
  const isDeadlineBeforeCurrentTime = isBefore(deadline, currentDate)

  switch (true) {
    case isDeadlineDay && isDeadlineAfterCurrentTime:
      return DEADLINE_TEXT_COLOR_ROLLING
    case isDeadlineAfterCurrentTime:
      return DEADLINE_TEXT_COLOR_EARLY
    case isDeadlineBeforeCurrentTime:
      return DEADLINE_TEXT_COLOR_OVERDUE
    default:
      return DEADLINE_TEXT_COLOR_DEFAULT
  }
}

export function getEntityDeadlineStatusColorByDate(deadline) {
  return { textColor: getEntityDeadlineStatusTextColor(deadline) }
}

export function getEntityDeadlineStatusRequestColorProperties(
  deadline,
  status
) {
  const isActiveStatus =
    isRequestPendingStatus(status) || isRequestInProgressStatus(status)

  return isActiveStatus
    ? getEntityDeadlineStatusColorByDate(deadline)
    : {
        backgroundColor: DEADLINE_BG_COLOR_DEFAULT,
        textColor: DEADLINE_TEXT_COLOR_DEFAULT,
      }
}
